import { render, staticRenderFns } from "./Signup-Studio.vue?vue&type=template&id=18fe2a49&scoped=true&"
import script from "./Signup-Studio.vue?vue&type=script&lang=js&"
export * from "./Signup-Studio.vue?vue&type=script&lang=js&"
import style0 from "./Signup-Studio.vue?vue&type=style&index=0&id=18fe2a49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fe2a49",
  null
  
)

export default component.exports